import { render } from "./EventMainDetails.vue?vue&type=template&id=5e11531b&scoped=true"
import script from "./EventMainDetails.vue?vue&type=script&lang=js"
export * from "./EventMainDetails.vue?vue&type=script&lang=js"

import "./EventMainDetails.vue?vue&type=style&index=0&id=5e11531b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e11531b"]])

export default __exports__